var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.9683 0.51709V22.1972H12.5011L6.71973 16.4158H2.6829C1.4876 16.4158 0.514893 15.4431 0.514893 14.2478V8.46645C0.514893 7.27115 1.4876 6.29845 2.6829 6.29845H6.71973L12.5011 0.51709H14.9683ZM13.5229 1.96243H13.0995L7.74159 7.32029V15.394L13.0995 20.7518H13.5229V1.96243ZM21.9113 3.69149C23.9578 5.73952 25.0852 8.46111 25.0852 11.3576C25.0852 14.2526 23.9578 16.9742 21.9113 19.0222L20.8894 18.0003C22.6643 16.2255 23.6399 13.8667 23.6399 11.3576C23.6399 8.847 22.6643 6.48822 20.8894 4.71334L21.9113 3.69149ZM18.8513 6.75951C20.0755 8.00106 20.7491 9.63429 20.7491 11.3571C20.7491 13.08 20.0755 14.7132 18.8513 15.9548L17.8208 14.9401C18.7776 13.9703 19.3037 12.6984 19.3037 11.3571C19.3037 10.0159 18.7776 8.74396 17.8208 7.77414L18.8513 6.75951ZM6.29625 7.74378H2.6829C2.28543 7.74378 1.96023 8.06755 1.96023 8.46645V14.2478C1.96023 14.6467 2.28543 14.9705 2.6829 14.9705H6.29625V7.74378Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.b7714809f42142d6c1152a614c086baf.svg";
export { ForwardRef as ReactComponent };